module.exports = __webpack_public_path__ + "img/installation.51d24bb0.svg";